(($) => {
  Drupal.behaviors.hwpHero = {
    attach(context) {
      $(
        once(
          'hwp-hero-slider-trigger',
          '.hwp-hero--carousel .js-hwp-hero-slider-trigger',
          context,
        ),
      ).each(function () {
        const hero = $(this);
        const navigation = hero.next('.hwp-pager');

        hero.slick({
          arrows: true,
          dots: true,
          slidesToShow: 1,
          dotsClass: 'hwp-pager__items',
          appendArrows: navigation,
          appendDots: navigation,
          prevArrow:
            '<button type="button" class="hwp-pager__item hwp-pager__item--previous" aria-label="Previous"><span class="material-icon" aria-hidden="true">chevron_left</span></button>',
          nextArrow:
            '<button type="button" class="hwp-pager__item hwp-pager__item--next" aria-label="Next"><span class="material-icon" aria-hidden="true">chevron_right</span></button>',
        });

        const pages = navigation.find('li');
        const maxPages = 5;

        function setNavEllipsis(nextSlide) {
          if (pages.length < maxPages) {
            return;
          }

          // Hide all dots except the first and last and reset the siblings class.
          pages
            .not(':first')
            .not(':last')
            .addClass('hwp-hidden')
            .removeClass('sibling');

          const currentPage = pages.eq(nextSlide);
          currentPage.removeClass('hwp-hidden');

          const prevPage = currentPage.prev();
          const nextPage = currentPage.next();

          if (nextPage.length) {
            nextPage.removeClass('hwp-hidden').addClass('sibling');
          }

          if (prevPage.length) {
            prevPage.removeClass('hwp-hidden').addClass('sibling');
          }

          switch (nextSlide) {
            case 0:
              // Next slide is the first slide
              nextPage.removeClass('sibling').next().removeClass('hwp-hidden');
              break;

            case 1:
              // Next slide is the second slide
              prevPage.removeClass('sibling');
              nextPage.removeClass('sibling');
              break;

            case 2:
              // Next slide is the third slide
              prevPage.removeClass('sibling');
              break;

            case pages.length - 1:
              // Next slide is the last slide
              prevPage.removeClass('sibling').prev().removeClass('hwp-hidden');
              break;

            case pages.length - 2:
              // Next slide is one slide before the last slide
              nextPage.removeClass('sibling');
              prevPage.removeClass('sibling');
              break;

            case pages.length - 3:
              // Next slide is two slides before the last slide
              nextPage.removeClass('sibling');
              break;

            default:
              break;
          }

          // Toggle ellipsis class based on visibility of adjacent hidden dots
          pages
            .first()
            .toggleClass(
              'hwp-pager__item--ellipsis',
              !!pages.first().next('.hwp-hidden').length,
            );

          pages
            .last()
            .toggleClass(
              'hwp-pager__item--ellipsis',
              !!pages.last().prev('.hwp-hidden').length,
            );
        }

        window.dataLayer = window.dataLayer || [];
        // Attach tracking for next and previous buttons
        const navigationConfigs = [
          {
            selector: '.hwp-pager__item--previous',
            eventAction: 'selected hero slider left arrow',
          },
          {
            selector: '.hwp-pager__item--next',
            eventAction: 'selected hero slider right arrow',
          },
        ];

        navigationConfigs.forEach(({ selector, eventAction }) => {
          navigation.find(selector).on('click', function () {
            const $currentSlide = hero.find('.slick-current');
            const title =
              $currentSlide.find('.hwp-hero__title').text().trim() ||
              'not available';
            const position =
              $currentSlide.find('.hwp-hero__slide').data('position') ||
              'not available';

            window.dataLayer.push({
              event: 'hero_component_selected',
              event_origin: 'front-end',
              event_vars: {
                content_title: title,
                position_number: position.toLowerCase(),
                event_action: eventAction,
                link_url: 'not available',
                component_name: 'hero component',
                page_url_clean: window.location.href.split(/[?#]/)[0],
              },
            });
          });
        });

        // Attach tracking for pager clicks
        navigation.find('.hwp-pager__items button').on('click', function () {
          const pageNumber = $(this).text().trim() || 'unknown';
          const $currentSlide = hero.find('.slick-current');
          const title =
            $currentSlide.find('.hwp-hero__title').text().trim() ||
            'not available';
          const position =
            $currentSlide.find('.hwp-hero__slide').data('position') ||
            'not available';

          window.dataLayer.push({
            event: 'hero_component_selected',
            event_origin: 'front-end',
            event_vars: {
              content_title: title,
              position_number: position.toLowerCase(),
              event_action: `selected hero pagination | ${pageNumber}`,
              link_url: 'not available',
              component_name: 'hero component',
              page_url_clean: window.location.href.split(/[?#]/)[0],
            },
          });
        });

        hero.on(
          'beforeChange',
          function (event, slick, currentSlide, nextSlide) {
            setNavEllipsis(nextSlide);
          },
        );

        setNavEllipsis(0);
      });
    },
  };
})(jQuery);
